import React, { useEffect, useState } from 'react';
import { Card, CardContent, Button, Modal } from '@mui/material';
import './PricingPlans.css';
import pricing_checkmark from '../../assets/images/pricing_chechkmark.svg';
import { APPRENTICE, FREE, MASTER, ORACLE, APPRENTICE_TEST, FREE_TEST, MASTER_TEST, ORACLE_TEST } from './PaymentConstants';
import pricing_x from '../../assets/images/x_icon.svg';
import pricing_neutral from '../../assets/images/pricing_neutral.svg';
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';

const plans = [
	{
		title: 'Free',
		yearlyPrice: '$0',
		biWeeklyPrice: '$0',
		description: <div style={{ fontFamily: 'Avenir' }}>Get started with +EV betting, risk-free.</div>,
		features: [
			{ label: 'Compare odds across sportsbooks', icon: pricing_checkmark },
			{ label: 'One-click bet links', icon: pricing_checkmark },
			{ label: 'Pregame plays', icon: pricing_checkmark },
			{ label: 'No live plays', icon: pricing_x },
			{ label: 'No Arbitrage Screener', icon: pricing_x },
			{ label: 'View top play', icon: pricing_neutral },
			{ label: '8 scans per day', icon: pricing_neutral },
			{ label: <span style={{ paddingTop: 2, paddingBottom: 2, fontWeight: 300 }}>Up to 5 sportsbooks</span>, icon: pricing_neutral },
			{ label: 'Up to 2 leagues', icon: pricing_neutral },
			{ label: 'WagerWiz sharp odds', icon: pricing_checkmark },
			{ label: 'No custom sharp books', icon: pricing_x },
			{ label: 'No auto-refresh plays', icon: pricing_x },
			{ label: <div style={{ fontWeight: 300 }}>Tag placed bets</div>, icon: pricing_checkmark },
			{ label: <div style={{ fontWeight: 300 }}>Line history graphs</div>, icon: pricing_checkmark },
			{ label: 'No new play notifications', icon: pricing_x },
		],
		yearlyId: FREE.yearly,
		biweeklyId: FREE.biweekly,
		yearlyLink: FREE.link.yearly,
		biweeklyLink: FREE.link.biweekly,
		// yearlyId: FREE_TEST.yearly,
		// biweeklyId: FREE_TEST.biweekly,
		// yearlyLink: FREE_TEST.link.yearly,
		// biweeklyLink: FREE_TEST.link.biweekly,
	},
	{
		title: '🔨 Apprentice',
		yearlyPriceDiscounted: '$699',
		biWeeklyPriceDiscounted: '$39.99',
		yearlyPrice: '$899',
		biWeeklyPrice: '$49.99',
		description: <>Serious tools for serious bettors.</>,
		features: [
			{ label: 'Compare odds across sportsbooks', icon: pricing_checkmark },
			{ label: 'One-click bet links', icon: pricing_checkmark },
			{ label: 'Pregame plays', icon: pricing_checkmark },
			{ label: 'No live plays', icon: pricing_x },
			{ label: 'No Arbitrage Screener', icon: pricing_x },
			{ label: 'View all plays', icon: pricing_checkmark },
			{ label: '10 scans per day', icon: pricing_neutral },
			{ label: <div style={{ paddingTop: 2, paddingBottom: 2, fontWeight: 300 }}>Up to 5 sportsbooks</div>, icon: pricing_neutral },
			{ label: 'Up to 2 leagues', icon: pricing_neutral },
			{ label: 'WagerWiz sharp odds', icon: pricing_checkmark },
			{ label: 'No custom sharp books', icon: pricing_x },
			{ label: 'No auto-refresh plays', icon: pricing_x },
			{ label: 'No tagging placed bets', icon: pricing_x },
			{ label: 'No line history graphs', icon: pricing_x },
			{ label: 'No new play notifications', icon: pricing_x },
		],
		yearlyId: APPRENTICE.yearly,
		biweeklyId: APPRENTICE.biweekly,
		yearlyLink: APPRENTICE.link.yearly,
		biweeklyLink: APPRENTICE.link.biweekly,
		// yearlyId: APPRENTICE_TEST.yearly,
		// biweeklyId: APPRENTICE_TEST.biweekly,
		// yearlyLink: APPRENTICE.link.yearly,
		// biweeklyLink: APPRENTICE.link.biweekly,
	},
	{
		title: '🪄 Visionary',
		yearlyPriceDiscounted: '$899',
		biWeeklyPriceDiscounted: '$43.99',
		yearlyPrice: '$1199',
		biWeeklyPrice: '$62.99',
		description: 'Maximize EV. Minimize missed opportunities.',
		features: [
			{ label: 'Compare odds across sportsbooks', icon: pricing_checkmark },
			{ label: 'One-click bet links', icon: pricing_checkmark },
			{ label: 'Pregame plays', icon: pricing_checkmark },
			{ label: 'Live plays', icon: pricing_checkmark },
			{ label: 'Arbitrage Screener', icon: pricing_checkmark },
			{ label: 'View all plays', icon: pricing_checkmark },
			{ label: 'Unlimited scans', icon: pricing_checkmark },
			{ label: 'Unlimited sportsbooks', icon: pricing_checkmark },
			{ label: 'Unlimited leagues', icon: pricing_checkmark },
			{ label: 'WagerWiz sharp odds', icon: pricing_checkmark },
			{ label: 'No custom sharp books', icon: pricing_x },
			{ label: <div style={{ fontWeight: 300 }}>Auto-refresh plays</div>, icon: pricing_checkmark },
			{ label: <div style={{ fontWeight: 300 }}>Tag placed bets</div>, icon: pricing_checkmark },
			{ label: 'No line history graphs', icon: pricing_x },
			{ label: 'No new play notifications', icon: pricing_x },
		],
		yearlyId: MASTER.yearly,
		biweeklyId: MASTER.biweekly,
		yearlyLink: MASTER.link.yearly,
		biweeklyLink: MASTER.link.biweekly,
		// yearlyId: MASTER_TEST.yearly,
		// biweeklyId: MASTER_TEST.biweekly,
		// yearlyLink: MASTER_TEST.link.yearly,
		// biweeklyLink: MASTER_TEST.link.biweekly,
	},
	{
		title: '🔮 Oracle',
		yearlyPriceDiscounted: '$999',
		biWeeklyPriceDiscounted: '$51.99',
		yearlyPrice: '$1399',
		biWeeklyPrice: '$79.99',
		description: 'Everything you need to dominate. Nothing missing.',
		features: [
			{ label: 'Compare odds across sportsbooks', icon: pricing_checkmark },
			{ label: 'One-click bet links', icon: pricing_checkmark },
			{ label: 'Pregame plays', icon: pricing_checkmark },
			{ label: 'Live plays', icon: pricing_checkmark },
			{ label: 'Arbitrage Screener', icon: pricing_checkmark },
			{ label: 'View all plays', icon: pricing_checkmark },
			{ label: 'Unlimited scans', icon: pricing_checkmark },
			{ label: 'Unlimited sportsbooks', icon: pricing_checkmark },
			{ label: 'Unlimited leagues', icon: pricing_checkmark },
			{ label: 'WagerWiz sharp odds', icon: pricing_checkmark },
			{ label: 'Custom sharp books', icon: pricing_checkmark },
			{ label: <div style={{ fontWeight: 300 }}>Auto-refresh plays</div>, icon: pricing_checkmark },
			{ label: <div style={{ fontWeight: 300 }}>Tag placed bets</div>, icon: pricing_checkmark },
			{ label: <div style={{ fontWeight: 300 }}>Line history graphs</div>, icon: pricing_checkmark },
			{ label: 'New play notifications', icon: pricing_checkmark },
		],
		yearlyId: ORACLE.yearly,
		biweeklyId: ORACLE.biweekly,
		yearlyLink: ORACLE.link.yearly,
		biweeklyLink: ORACLE.link.biweekly,
		// yearlyId: ORACLE_TEST.yearly,
		// biweeklyId: ORACLE_TEST.biweekly,
		// yearlyLink: ORACLE_TEST.link.yearly,
		// biweeklyLink: ORACLE_TEST.link.biweekly,
	},
];

const getNumeric = (str) => parseFloat(str.replace(/[^0-9.]/g, ''));

const handleSelectPlan = async (email, stripeCustomerId, priceId, trial=false, accessToken) => {
	const checkoutLink = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/checkout_session?email=${email}&stripe_user_id=${stripeCustomerId}&price_id=${priceId}&trial=${trial}`, {
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	});

	return checkoutLink.data?.url;
};

export const PricingPlansDiscounts = (props) => {
	const { paymentCycle, onPlanSelected } = props;

	const { user, loginWithRedirect } = useAuth0();

	// const [country, setCountry] = useState(null);

	// useEffect(() => {
	// 	const fetchGeo = async () => {
	// 		try {
	// 			const res = await fetch('https://ipapi.co/json/');
	// 			const data = await res.json();
	// 			setCountry(data.country);
	// 		} catch (err) {
	// 			console.error('Failed to fetch geolocation:', err);
	// 		}
	// 	};

	// 	fetchGeo();
	// }, []);

	const [isMobile, setIsMobile] = useState(window.innerWidth <= 750);
	const [expandedPlan, setExpandedPlan] = useState(null);

	useEffect(() => {
		const handleResize = () => {
			if (window.innerWidth >= 750) {
				setIsMobile(false);
			} else {
				setIsMobile(true);
			}
		};
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	const [paymentLinks, setPaymentLinks] = useState({});
	const [isLoading, setIsLoading] = useState(false);
	const { getAccessTokenSilently } = useAuth0();
	const [accessToken, setAccessToken] = useState();

	useEffect(() => {
		const getAccessToken = async () => {
			try {
				const tkn = await getAccessTokenSilently();
				setAccessToken(tkn);
			} catch (e) {
				console.log('e: ', e);
			}
		};

		getAccessToken();
	});

	useEffect(() => {
		const fetchLinks = async () => {
			setIsLoading(true);
			const newLinks = {};
			for (const plan of plans) {
				const priceId = paymentCycle === 'BiWeekly' ? plan.biweeklyId : plan.yearlyId;

				try {
					let res = paymentCycle === 'BiWeekly' ? plan.biweeklyLink : plan.yearlyLink;
					// const access_token = window.localStorage.getItem('access_token');
					// const res = (
					// 	await axios.get(`${process.env.REACT_APP_BACKEND_URL}/payment_links?priceId=${priceId}`, {
					// 		headers: {
					// 			Authorization: `Bearer ${access_token}`,
					// 		},
					// 	})
					// ).data;
					newLinks[priceId] = res;
				} catch (err) {
					console.error('Failed to fetch payment link', err);
				}
			}
			setPaymentLinks(newLinks);
			setIsLoading(false);
		};

		fetchLinks();
	}, [paymentCycle]);

	const userdb = JSON.parse(window.localStorage.getItem('userdb'));
	const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false);
	const [upgradePlanSelected, setUpgradePlanSelected] = useState();
	const [isUpgradeConfirmed, setIsUpgradeConfirmed] = useState(false);

	const isMasterOrOracleOrApprentice =
		(userdb?.stripe_plan?.nickname?.includes('Visionary') &&
			userdb?.stripe_plan.active &&
			userdb?.stripe_subscription !== null &&
			userdb?.stripe_status !== 'deleted' &&
			userdb.stripe_status !== 'past_due') ||
		(userdb?.stripe_plan?.nickname?.includes('Oracle') &&
			userdb?.stripe_plan.active &&
			userdb?.stripe_subscription !== null &&
			userdb?.stripe_status !== 'deleted' &&
			userdb.stripe_status !== 'past_due') ||
		(userdb?.stripe_plan?.nickname?.includes('Apprentice') &&
			userdb?.stripe_plan.active &&
			userdb?.stripe_subscription !== null &&
			userdb?.stripe_status !== 'deleted' &&
			userdb.stripe_status !== 'past_due');
	// if user has an active plan, upgrade their plan instead of creating a new checkout session

	useEffect(() => {
		if (isUpgradeConfirmed) {
			setTimeout(function () {
				window.location.href = '/';
			}, 6000);
		}
	}, [isUpgradeConfirmed]);
	console.log('userdb: ', userdb);

	if (!isMobile) {
		return (
			<div className="flex justify-center min-h-screen bg-gray-900 text-white py-8 px-4">
				<div className="w-full max-w-7xl grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
					{plans.map((plan) => {
						const isBiWeekly = paymentCycle === 'BiWeekly';
						const originalPrice = isBiWeekly ? plan.biWeeklyPrice : plan.yearlyPrice;
						const discountedPrice = isBiWeekly ? plan.biWeeklyPriceDiscounted : plan.yearlyPriceDiscounted;

						const hasDiscount = !!discountedPrice && getNumeric(originalPrice) > getNumeric(discountedPrice);

						const discountPercent = hasDiscount ? Math.round(((getNumeric(originalPrice) - getNumeric(discountedPrice)) / getNumeric(originalPrice)) * 100) : 0;

						const pricePhrase = isBiWeekly ? <>biweekly, USD</> : 'yearly, USD';

						const priceId = isBiWeekly ? plan.biweeklyId : plan.yearlyId;
						const link = paymentLinks[priceId];

						// console.log('link: ', link);

						return (
							<Card
								sx={{
									backgroundColor: '#17191d !important',
									color: 'white',
									border: '1px solid #22262e',
									height: '100%',
									display: 'flex',
									flexDirection: 'column',
								}}
								key={plan.title}
								className="bg-gray-800 rounded-2xl shadow-xl">
								<Modal
									open={isUpgradeModalOpen}
									onClose={() => {
										setIsUpgradeModalOpen(false);
									}}>
									<div
										style={{
											position: 'relative',
											outline: 'none',
											backgroundColor: '#22262e',
											width: '45%',
											margin: 'auto',
											marginTop: '20vh',
											padding: 10,
											borderRadius: 8,
											paddingTop: 40,
											paddingBottom: 40,
											textAlign: 'center',
										}}>
										<button
											onClick={() => setIsUpgradeModalOpen(false)}
											style={{
												position: 'absolute',
												top: 10,
												right: 10,
												background: 'transparent',
												border: 'none',
												color: 'white',
												fontSize: 24,
												cursor: 'pointer',
											}}>
											&times;
										</button>
										<div>
											Confirm you want to change your plan to <br /> {upgradePlanSelected?.title} ({isBiWeekly ? 'biweekly' : 'yearly'})
										</div>
										<Button
											style={{
												backgroundColor: '#0b63f4',
												color: 'white',
												cursor: 'pointer',
												maxWidth: 200,
												fontFamily: 'Avenir',
												marginTop: 20,
												display: isUpgradeConfirmed ? 'none' : '',
											}}
											onClick={async () => {
												const upgrade = await axios.get(
													`${process.env.REACT_APP_BACKEND_URL}/upgrade_plan?price_id=${
														isBiWeekly ? upgradePlanSelected.biweeklyId : upgradePlanSelected.yearlyId
													}&subscription_id=${userdb.stripe_subscription}&subscription_item_id=${
														userdb.stripe_data?.items?.data?.[userdb?.stripe_data?.items?.data?.length - 1]?.id
													}`,
													{
														headers: {
															Authorization: `Bearer ${accessToken}`,
														},
													}
												);

												if (upgrade.data.id) {
													setIsUpgradeConfirmed(true);
												}
											}}>
											{!isUpgradeConfirmed && 'Confirm'}
										</Button>
										{isUpgradeConfirmed && <div className="mt-4">Plan change confirmed! <br /><br /> You will be redirected to WagerWiz in 6 seconds...</div>}
									</div>
								</Modal>
								<CardContent sx={{ display: 'flex', flexDirection: 'column', flex: 1, padding: '24px !important' }}>
									<h2 style={{ fontFamily: 'Avenir' }} className="text-xl font-bold mb-3">
										{plan.title}
									</h2>
									<div style={{ fontFamily: 'Avenir', minHeight: '100px' }} className="flex flex-col mb-4">
										{hasDiscount ? (
											<>
												<div style={{ fontFamily: 'Avenir' }} className="flex items-end space-x-2 mb-1">
													<p style={{ fontFamily: 'Avenir' }} className="text-4xl font-extrabold">
														{discountedPrice}
													</p>
													<p style={{ fontFamily: 'Avenir' }} className="text-gray-400 text-xl line-through">
														{originalPrice}
													</p>
												</div>
												{plan.title !== 'Free' && (
													<div
														style={{
															fontSize: '0.8rem',
															color: 'white',
															opacity: 0.75,
															fontFamily: 'Avenir',
															marginBottom: '4px',
														}}>
														{pricePhrase}
													</div>
												)}
												<p style={{ fontFamily: 'Avenir' }} className="text-green-400 text-sm font-medium">
													Discount - {discountPercent}% off
												</p>
											</>
										) : (
											<>
												<p style={{ fontFamily: 'Avenir' }} className="text-4xl font-extrabold mb-1">
													{originalPrice}
												</p>
												{plan.title !== 'Free' && (
													<div
														style={{
															fontSize: '0.8rem',
															color: 'white',
															opacity: 0.75,
															fontFamily: 'Avenir',
														}}>
														{pricePhrase}
													</div>
												)}
											</>
										)}
									</div>
									<p style={{ fontFamily: 'Avenir' }} className="text-gray-400 mb-6 min-h-[3rem]">
										{plan.description}
									</p>
									<div style={{ marginTop: 'auto', marginBottom: '24px' }}>
										{!isLoading && (
											<Button
												style={{
													backgroundColor: plan.title !== 'Free' || !isMasterOrOracleOrApprentice ? '#0b63f4' : '#4a5564',
													color: 'white',
													cursor: plan.title !== 'Free' || !isMasterOrOracleOrApprentice ? 'pointer' : 'default',
													width: '100%',
													fontFamily: 'Avenir',
													padding: '10px 16px',
													fontSize: '16px',
													fontWeight: 600,
													borderRadius: '8px',
												}}
												onClick={async () => {
													// window.location.href = link;
													if (!isMasterOrOracleOrApprentice) {
														if (user) {
															// Mark intro as completed when user selects any plan
															const token = await getAccessTokenSilently();
															await axios.get(`${process.env.REACT_APP_BACKEND_URL}/intro_completed?intro_completed=true&email=${user.email}`, {
																headers: {
																	Authorization: `Bearer ${token}`,
																},
															});
															
															// window.open(link, '_blank');
															const planLink = await handleSelectPlan(user.email, userdb.stripeCustomerId, priceId, ['🪄 Visionary', '🔮 Oracle'].includes(plan.title) && paymentCycle === 'BiWeekly' && !userdb?.stripe_plan, accessToken);
															if (onPlanSelected) {
																onPlanSelected(planLink);
															} else if (planLink) {
																window.location.href = planLink;
															} else {
																window.location.href = '/';
															}
														} else {
															loginWithRedirect({
																authorizationParams: {
																	// prompt: 'sign select_account',
																	screen_hint: 'signup',
																},
															});
														}
													} else {
														// upgrade the user's existing plan
														// open the modal asking them to confirm that they want to upgrade (with their plan filled out)
														if (plan.title !== 'Free') {
															setIsUpgradeModalOpen(true);
															setUpgradePlanSelected(plan);
														}
													}
												}}
												className={`${
													(plan.title !== 'Free' || !isMasterOrOracleOrApprentice) && 'hover:bg-blue-700 select-plan-button'
												} text-white font-semibold cursor-pointer`}>
												{/* Select plan */}
												{!isMasterOrOracleOrApprentice
													? ['🪄 Visionary', '🔮 Oracle'].includes(plan.title) && paymentCycle === 'BiWeekly' && !userdb?.stripe_plan
														? 'Start 7-day trial'
														: 'Select plan'
													: ''}
												{isMasterOrOracleOrApprentice ? (['🪄 Visionary', '🔮 Oracle'].includes(plan.title) && paymentCycle === 'BiWeekly' ? 'Change Plan' : 'Change plan') : ''}
											</Button>
										)}
									</div>

									<h3 style={{ fontFamily: 'Avenir' }} className="text-lg font-semibold mb-3">
										Features
									</h3>
									<ul style={{ listStyle: 'none', padding: 0, margin: 0, flex: 1 }}>
										{plan.features.map((feature, index) => (
											<li key={`${plan.title}-feature-${index}`} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '8px', minHeight: '24px' }}>
												<img 
													style={{ 
														opacity: 0.8, 
														width: '16px', 
														height: '16px',
														marginRight: '8px',
														marginTop: '2px',
														flexShrink: 0,
													}} 
													src={feature.icon} 
													alt="" 
												/>
												{typeof feature.label === 'string' ? (
													<span style={{ fontFamily: 'Avenir', fontSize: '14px', lineHeight: '1.5' }}>{feature.label}</span>
												) : (
													<div style={{ fontFamily: 'Avenir', fontSize: '14px', lineHeight: '1.5', flex: 1 }}>{feature.label}</div>
												)}
											</li>
										))}
									</ul>
								</CardContent>
							</Card>
						);
					})}
				</div>
			</div>
		);
	} else {
		return (
			<div className="w-full px-4 py-6 bg-gray-900 min-h-screen">
				<Modal
					open={isUpgradeModalOpen}
					onClose={() => {
						setIsUpgradeModalOpen(false);
					}}>
					<div
						style={{
							position: 'relative',
							outline: 'none',
							backgroundColor: '#22262e',
							width: '85%',
							margin: 'auto',
							marginTop: '20vh',
							padding: 10,
							borderRadius: 8,
							paddingTop: 40,
							paddingBottom: 40,
							textAlign: 'center',
						}}>
						<button
							onClick={() => setIsUpgradeModalOpen(false)}
							style={{
								position: 'absolute',
								top: 10,
								right: 10,
								background: 'transparent',
								border: 'none',
								color: 'white',
								fontSize: 24,
								cursor: 'pointer',
							}}>
							&times;
						</button>
						<div>
							Confirm you want to change your plan to <br /> {upgradePlanSelected?.title} ({paymentCycle === 'BiWeekly' ? 'biweekly' : 'yearly'})
						</div>
						<Button
							style={{
								backgroundColor: '#0b63f4',
								color: 'white',
								cursor: 'pointer',
								maxWidth: 200,
								fontFamily: 'Avenir',
								marginTop: 20,
								display: isUpgradeConfirmed ? 'none' : '',
							}}
							onClick={async () => {
								const isBiWeekly = paymentCycle === 'BiWeekly';
								const upgrade = await axios.get(
									`${process.env.REACT_APP_BACKEND_URL}/upgrade_plan?price_id=${
										isBiWeekly ? upgradePlanSelected.biweeklyId : upgradePlanSelected.yearlyId
									}&subscription_id=${userdb.stripe_subscription}&subscription_item_id=${
										userdb.stripe_data?.items?.data?.[userdb?.stripe_data?.items?.data?.length - 1]?.id
									}`,
									{
										headers: {
											Authorization: `Bearer ${accessToken}`,
										},
									}
								);

								if (upgrade.data.id) {
									setIsUpgradeConfirmed(true);
								}
							}}>
							{!isUpgradeConfirmed && 'Confirm'}
						</Button>
						{isUpgradeConfirmed && <div className="mt-4">Plan change confirmed! <br /><br /> You will be redirected to WagerWiz in 6 seconds...</div>}
					</div>
				</Modal>
				<div className="flex flex-col gap-4 max-w-md mx-auto">
					{plans.map((plan) => {
						const isBiWeekly = paymentCycle === 'BiWeekly';
						const originalPrice = isBiWeekly ? plan.biWeeklyPrice : plan.yearlyPrice;
						const discountedPrice = isBiWeekly ? plan.biWeeklyPriceDiscounted : plan.yearlyPriceDiscounted;

						const hasDiscount = !!discountedPrice && getNumeric(originalPrice) > getNumeric(discountedPrice);
						const discountPercent = hasDiscount ? Math.round(((getNumeric(originalPrice) - getNumeric(discountedPrice)) / getNumeric(originalPrice)) * 100) : 0;
						const pricePhrase = isBiWeekly ? <>biweekly, USD</> : 'yearly, USD';

						const priceId = isBiWeekly ? plan.biweeklyId : plan.yearlyId;
						const link = paymentLinks[priceId];
						const isExpanded = expandedPlan === plan.title;

						return (
							<Card
								sx={{
									backgroundColor: '#17191d !important',
									color: 'white',
									border: '1px solid #22262e',
									width: '100%',
									boxSizing: 'border-box',
									overflow: 'hidden',
								}}
								className="bg-gray-800 rounded-2xl shadow-xl"
								key={plan.title}>
								<CardContent sx={{ padding: '20px !important' }}>
									{/* Summary Section - Always Visible */}
									<div 
										onClick={() => setExpandedPlan(isExpanded ? null : plan.title)}
										style={{ cursor: 'pointer' }}
										className="flex items-center justify-between">
										<div className="flex-1">
											<h2 style={{ fontFamily: 'Avenir' }} className="text-xl font-bold mb-2">
												{plan.title}
											</h2>
											<div style={{ fontFamily: 'Avenir' }} className="flex items-end space-x-2 mb-2">
												{hasDiscount ? (
													<>
														<p style={{ fontFamily: 'Avenir' }} className="text-3xl font-extrabold">
															{discountedPrice}
														</p>
														<p style={{ fontFamily: 'Avenir' }} className="text-gray-400 text-lg line-through">
															{originalPrice}
														</p>
													</>
												) : (
													<p style={{ fontFamily: 'Avenir' }} className="text-3xl font-extrabold">
														{originalPrice}
													</p>
												)}
												{plan.title !== 'Free' && (
													<p style={{ fontFamily: 'Avenir', fontSize: '0.75rem', color: 'white', opacity: 0.75, marginBottom: '4px' }}>
														{pricePhrase}
													</p>
												)}
											</div>
											{hasDiscount && plan.title !== 'Free' && (
												<p style={{ fontFamily: 'Avenir' }} className="text-green-400 text-xs font-medium mb-2">
													Discount - {discountPercent}% off
												</p>
											)}
											<p style={{ fontFamily: 'Avenir' }} className="text-gray-400 text-sm mt-2">
												{plan.description}
											</p>
										</div>
										<div style={{ marginLeft: '12px', fontSize: '24px', color: '#9ca3af' }}>
											{isExpanded ? '−' : '+'}
										</div>
									</div>

									{/* Expanded Details Section */}
									{isExpanded && (
										<div style={{ marginTop: '20px', paddingTop: '20px', borderTop: '1px solid #22262e' }}>
											{!isLoading && (
												<Button
													style={{
														backgroundColor: plan.title !== 'Free' || !isMasterOrOracleOrApprentice ? '#0b63f4' : '#4a5564',
														color: 'white',
														cursor: plan.title !== 'Free' || !isMasterOrOracleOrApprentice ? 'pointer' : 'default',
														width: '100%',
														fontFamily: 'Avenir',
														padding: '12px 16px',
														fontSize: '16px',
														fontWeight: 600,
														borderRadius: '8px',
														marginBottom: '24px',
													}}
													onClick={async (e) => {
														e.stopPropagation();
														if (!isMasterOrOracleOrApprentice) {
															if (user) {
																// Mark intro as completed when user selects any plan
																const token = await getAccessTokenSilently();
																await axios.get(`${process.env.REACT_APP_BACKEND_URL}/intro_completed?intro_completed=true&email=${user.email}`, {
																	headers: {
																		Authorization: `Bearer ${token}`,
																	},
																});
																
																const planLink = await handleSelectPlan(user.email, userdb.stripeCustomerId, priceId, ['🪄 Visionary', '🔮 Oracle'].includes(plan.title) && paymentCycle === 'BiWeekly' && !userdb?.stripe_plan, accessToken);
																if (onPlanSelected) {
																	onPlanSelected(planLink);
																} else if (planLink) {
																	window.location.href = planLink;
																} else {
																	window.location.href = '/';
																}
															} else {
																loginWithRedirect({
																	authorizationParams: {
																		screen_hint: 'signup',
																	},
																});
															}
														} else {
															if (plan.title !== 'Free') {
																setIsUpgradeModalOpen(true);
																setUpgradePlanSelected(plan);
															}
														}
													}}
													className={`${(plan.title !== 'Free' || !isMasterOrOracleOrApprentice) && 'hover:bg-blue-700 select-plan-button'} text-white font-semibold cursor-pointer`}>
													{!isMasterOrOracleOrApprentice
														? ['🪄 Visionary', '🔮 Oracle'].includes(plan.title) && paymentCycle === 'BiWeekly' && !userdb?.stripe_plan
															? 'Start 7-day trial'
															: 'Select plan'
														: ''}
													{isMasterOrOracleOrApprentice ? (['🪄 Visionary', '🔮 Oracle'].includes(plan.title) && paymentCycle === 'BiWeekly' ? 'Change Plan' : 'Change plan') : ''}
												</Button>
											)}

											<h3 style={{ fontFamily: 'Avenir' }} className="text-lg font-semibold mb-3">
												Features
											</h3>
											<ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
												{plan.features
													.filter((feature) => feature.icon === pricing_checkmark || feature.icon === pricing_neutral)
													.map((feature, index) => (
														<li key={`${plan.title}-feature-included-${index}`} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '12px', minHeight: '24px' }}>
															<img 
																style={{ 
																	opacity: 0.8, 
																	width: '16px', 
																	height: '16px',
																	marginRight: '10px',
																	marginTop: '2px',
																	flexShrink: 0,
																}} 
																src={feature.icon} 
																alt="" 
															/>
															{typeof feature.label === 'string' ? (
																<span style={{ fontFamily: 'Avenir', fontSize: '14px', lineHeight: '1.5' }}>{feature.label}</span>
															) : (
																<div style={{ fontFamily: 'Avenir', fontSize: '14px', lineHeight: '1.5', flex: 1 }}>{feature.label}</div>
															)}
														</li>
													))}
												{plan.features
													.filter((feature) => feature.icon === pricing_x)
													.map((feature, index) => (
														<li key={`${plan.title}-feature-excluded-${index}`} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '12px', minHeight: '24px' }}>
															<img 
																style={{ 
																	opacity: 0.8, 
																	width: '16px', 
																	height: '16px',
																	marginRight: '10px',
																	marginTop: '2px',
																	flexShrink: 0,
																}} 
																src={feature.icon} 
																alt="" 
															/>
															{typeof feature.label === 'string' ? (
																<span style={{ fontFamily: 'Avenir', fontSize: '14px', lineHeight: '1.5' }}>{feature.label}</span>
															) : (
																<div style={{ fontFamily: 'Avenir', fontSize: '14px', lineHeight: '1.5', flex: 1 }}>{feature.label}</div>
															)}
														</li>
													))}
											</ul>
										</div>
									)}
								</CardContent>
							</Card>
						);
					})}
				</div>
			</div>
		);
	}
};
